import React,{useRef} from "react";
import { useState } from "react";
import assets from "../../assets/assets.gif";
import axios from "axios";
import "../../Components/Addemployee/addemployee.css";

export default function UploadImage({directory, onfocus}) {
  const [loading, setLoading] = useState(false);
  // const [url, setUrl] = useState("");
  const [localUrl, setLocalUrl] = useState(null)

  const hiddenFileInput = useRef(null);

  const handlePictureUpload = () => {
    hiddenFileInput.current.click();
  };


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  function uploadSingleImage(base64) {
    setLoading(true);
    axios
      .post("http://localhost:5000/uploadImage", { image: base64 })
      .then((res) => {
        directory(res.data)
      })
      .then(() => setLoading(false))
      .catch(console.log);
  }

  // function uploadMultipleImages(images) {
  //   setLoading(true);
  //   axios
  //     .post("http://localhost:5000/uploadMultipleImages", { images })
  //     .then((res) => {
  //       setUrl(res.data);
  //       alert("Image uploaded Succesfully");
  //     })
  //     .then(() => setLoading(false))
  //     .catch(console.log);
  // }

  const uploadImage = async (event) => {
    onfocus()
    const files = event.target.files;
    setLocalUrl(URL.createObjectURL(event.target.files[0]))
    // console.log(files.length);

    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleImage(base64);
      return;
    }

    const base64s = [];
    for (var i = 0; i < files.length; i++) {
      var base = await convertBase64(files[i]);
      base64s.push(base);
    }
    // uploadMultipleImages(base64s);
  };

  function UploadInput() {
    return (
      <div className="add_emp_body_row" >
          <img id='add_emp_profile-img-container' onClick={handlePictureUpload} src={localUrl} alt='pictures'/>
          <button className="add_emp_butn-upload" onClick={handlePictureUpload}>
            Select Photo
          </button>
          <input 
            accept="image/*" 
            type='file' 
            onChange={uploadImage} 
            ref={hiddenFileInput} 
            style={{ display: "none" }}
          />
      </div>
    );
  }

  return (
    <div>
      <div>
        {loading ? 
          <div className="add_emp_body_row">
            <img src={assets} alt="alternative" id='add_emp_profile-img-container'/>{" "}
            <button disabled={true} className="add_emp_butn-upload" onClick={handlePictureUpload}>
            Select Photo
          </button>
          </div>
         : 
          <UploadInput />
        }
      </div>
    </div>
  );
}
